import React from 'react';

import withGrid from 'hocs/withGrid';
import useStoreTranslation from 'hooks/useStoreTranslation';
import { FlightResultResponse } from 'models/flightSearch';
import { getFormattedPrice } from 'utils/currency';

import SectorFlight from './components/SectorFlight';
import {
  Card,
  Body,
  Footer,
  Price,
  PriceContainer,
  ConfirmButton,
  Summary,
  PriceWrapper,
  Currency,
  FinalPriceWithTaxesMobile,
  BreakRulesMessage,
  NoBreakRulesMessage,
} from './styles';

interface Props {
  data: FlightResultResponse;
  onClick?: () => void;
  onConfirm?: () => void;
  testId?: string;
}

const CardExchangeFlight = ({ data, onClick, onConfirm, testId }: Props) => {
  const { t } = useStoreTranslation();
  const formattedPrice = (value: number) => getFormattedPrice({ value, currency: data?.price?.currencyCode, t });
  const formattedPriceTotal = formattedPrice(data?.price?.total);

  return (
    <Card>
      <Card.Wrapper onClick={onClick} data-testid={testId}>
        <Body>
          {data.sectors.map((sector, idx) => (
            <SectorFlight key={`sector-${idx}`} sector={sector} />
          ))}
        </Body>
      </Card.Wrapper>
      <Footer>
        <Summary>
          <PriceContainer>
            <PriceWrapper>
              <Price>{formattedPriceTotal?.formattedWithoutCode}</Price>
              <Currency>{formattedPriceTotal?.currency}</Currency>
            </PriceWrapper>
            <FinalPriceWithTaxesMobile>{t('flightsCard.finalPriceWithTaxes')}</FinalPriceWithTaxesMobile>
            {!data.isPreApproved && data.breakRulesMessage && data.breakRulesMessage?.length > 0 ? (
              <BreakRulesMessage>{t('flightDetails.outOfPolicies')}</BreakRulesMessage>
            ) : (
              <NoBreakRulesMessage>{t('flightDetails.withinPolicies')}</NoBreakRulesMessage>
            )}
          </PriceContainer>
          <ConfirmButton onClick={onConfirm}>{t('flightsCard.confirmButton')}</ConfirmButton>
        </Summary>
      </Footer>
    </Card>
  );
};

export default withGrid(CardExchangeFlight);
